import { Injectable } from '@angular/core';

@Injectable()
export class NotificationHandlerService<T> {

    private _notificationMap = new Map();


    public getNotificationNumber(): number {

        if (!this._notificationMap)
            return 0;

        let list = Array.from(this._notificationMap.values());
        return list.filter(not => not.type === 'danger').length;

    }

    public getNotifications(): Array<T> {
        return Array.from(this._notificationMap.values());
    }

    public push(item: T): string {
        let id = Math.random().toString(36).substr(2, 9);
        this._notificationMap.set(id, item);
        return id;
    }

    public remove(item: T): void {

        if (!this._notificationMap)
            return

        let valuesList = Array.from(this._notificationMap.values());
        let keysList = Array.from(this._notificationMap.keys());

        let remIndex = valuesList.indexOf(item);

        if (remIndex >= 0) {
            valuesList.splice(remIndex, 1);
            keysList.splice(remIndex, 1);
        }

        this._notificationMap = new Map();

        for (let i = 0; i < keysList.length; i++) {
            this._notificationMap.set(keysList[i], valuesList[i])
        }

    }

    public pushAll(itens: Array<T>): Array<string> {

        this._notificationMap = new Map();

        let keysList: Array<string> = [];
        for (let item of itens) {
            keysList.push(this.push(item));
        }
        return keysList;
    }

    public removeById(id: string): void {
        this._notificationMap.delete(id);
    }

    public hasItemById(id: string): boolean {
        return this._notificationMap.has(id);
    }

    public hasItem(item: T): boolean {
        let valuesList = Array.from(this._notificationMap.values());
        return valuesList.filter(handler => handler === item).length > 0;
    }

    public getById(id: string): T {
        return this._notificationMap.get(id);
    }
}
